import {default as _} from 'lodash';
import { Component, ViewChild, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import {default as GridColumnsJSON} from 'app/Shared/Component/cat-recon-comment-viewer/cat-recon-comment-viewer-grid-columns.json';
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { UserService } from "app/Shared/Services/user.service";
import { DataService } from 'app/Shared/Services/data.service';
import { CatReconCommentViewerService } from "./cat-recon-comment-viewer.service";
import { ConfirmationService,MessageService } from 'primeng/api';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { CatReconService } from 'app/Pages/cat-dashboard/cat-recon/cat-recon.service';
import { DatePipe, LowerCasePipe, NgClass,CommonModule} from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipListbox, MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatepickerCalendarComponent } from '../datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from '../datepicker-calendar/datepicker.service';

@Component({
    selector: 'app-cat-recon-comment-viewer',
    templateUrl: './cat-recon-comment-viewer.component.html',
    styleUrls: ['./cat-recon-comment-viewer.component.scss'],
    imports: [ConfirmDialogModule, FormsModule, MatProgressSpinnerModule, MatTooltipModule,
        MatExpansionModule, MatChipsModule, DialogModule, TableModule, ButtonModule, LowerCasePipe, NgClass,
        CommonModule, DatePipe, MatChipListbox, DatepickerCalendarComponent]
})
export class CatReconCommentViewerComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table | any;
  @Output() reloadCommentCount: EventEmitter<any> = new EventEmitter();
  @Input('selectedRow') selectedRow: any = [];
  @Input('selectedTabIndex') selectedTabIndex: any = [];
  @Input('tableName') tableName: any;
  @Input('groupName') groupName: any;
  cols :any= [];
  tbldatamsg = 'L o a d i n g . . . . .';
  isDataLoading: boolean = true;
  gridColumns: any = GridColumnsJSON;
  filterReportDate: any = [];
  todate: string = "";
  staticFilters: any = [];
  staticAvailableFilters: any = [];
  DefaultFilterArray: any = [];
  LastExecutionDate!: any[];
  catalystCommentData: any = [];
  isOpenDateRangeFilter: boolean | any = false;
  rowcount: number = 5;
  totalRecords : number = 0;
  startLimit: any = 0;
  endLimit!: number;
  pageNumber: any = 1;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  commentStatement: any;
  maxCharsLength: number = 256;
  panelRegion:any;
  columnKey:any;
  rowKey:any;
  cellValue:any;
  isActive: any;
  catReconCommentData?: any = [];
  panelNames: any[] = ['','Client & CAT','Client Data','CAT Data','CAT Submission', 'CAT Monthly Summary'];
  panelKeys: any[] = ['', 'clientCAT', 'clientData', 'catData', 'catSubmission', 'catMonthlySummary'];

  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public userService: UserService,
    public messageService: MessageService,
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public catReconService: CatReconService,
    public CatReconCommentViewerService: CatReconCommentViewerService,
    private datepickerService: DatepickerService,
    private sortPipe: SortPipe) {
      this.staticFilters = [{filterName: 'Report Date', filterValue: '', fieldName: 'reportDate'}, {filterName: 'Group Name', filterValue: '', fieldName: 'groupName'}, {filterName: 'Table Header', filterValue: '', fieldName: 'optedTableHeader'}, {filterName: 'Field Name', filterValue: '', fieldName: 'fieldName'}, {filterName: 'Field Value', filterValue: '', fieldName: 'fieldValue'}];
  }

  ngOnInit() {
    this.isDataLoading = false;
    /* Dynamically Add Rows Per Page for CAT Recon Comment Viewer Screen only */
    this.rowsPerPageOptions = [5, 10, ...this.constantService.DEFAULT_ROWSPERPAGEOPTION];

    let todate: any;
    todate = this.userService.getyyyyMMddDateFormate(this.userService.CATLastExecutionDate);
    this.LastExecutionDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionDate[0] = (todate);// Fromdate
      this.LastExecutionDate[1] = (todate);// Todate
      this.endLimit = this.rowcount;
      this.Limit = { 'Start': '0', 'End': this.endLimit };
      this.defaultFilter();
      this.getColumns();
      this.getData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedRow']) {
      this.getFiltersAvailability();
    }
    if(changes['selectedRow'] && !changes['selectedRow'].firstChange) {
      this.getData();
    }
  }

  getFiltersAvailability() {
    // Filter for Report Date
    let reportDateIndex = this.staticFilters.findIndex((Obj:any)=>Obj.filterName==="Report Date");
    this.staticFilters[reportDateIndex]["filterValue"] = "";

    if(!this.catReconService.isDisplayDateRangeFilter && reportDateIndex!==-1 && this.selectedRow && this.selectedRow.optedTableHeader && this.selectedRow.optedTableHeader.length===1) {
      /* Set Static Filter Values if From & to ReportDates available */
      if(this.selectedRow.fromReportDate && this.selectedRow.toReportDate) {
        this.staticFilters[reportDateIndex]["filterValue"] = [this.selectedRow.fromReportDate, this.selectedRow.toReportDate];
      } else {
        this.staticFilters[reportDateIndex]["filterValue"] = this.selectedRow.reportDate;
      }
    }
    /* Filters except Report Date */
    for(let i=0; i<this.staticFilters.length; i++) {
      if(!_.includes(["Report Date"], this.staticFilters[i]["filterName"])) {
        // Field Filter
        let fieldIndex = this.staticFilters.findIndex((Obj:any)=>Obj.filterName===this.staticFilters[i]["filterName"]);
        this.staticFilters[fieldIndex]["filterValue"] = "";
        if(fieldIndex!==-1 && this.selectedRow && this.selectedRow[this.staticFilters[i]["fieldName"]] && this.selectedRow[this.staticFilters[i]["fieldName"]].length > 0) {
          this.staticFilters[fieldIndex]["filterValue"] = this.selectedRow[this.staticFilters[i]["fieldName"]];
        }
      }
    }

    this.staticAvailableFilters = this.staticFilters.filter((obj:any) => obj.filterValue);
  }

  getResolutionWidth() {
    return window.innerWidth - 400;
  }

  getColumns() {
    let column: any = this.gridColumns;
    if (column != null || column != undefined) {
      this.cols = this.gridService.getGridColumns(column);
    }
  }
  
  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': 'IS', 
      'values': this.LastExecutionDate, 'time': '', 'datatype': 'DateRange', 
      'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
  }

  onSelectionChange(selection: any[]) {
    for (let i = selection.length - 1; i >= 0; i--) {
      let data = selection[i];
      if(!data.isActive) {
        selection.splice(i, 1);
      }
    }
    this.dataService.roeSelectedRecords = selection;
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  sort(event:any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.catalystCommentData = this.sortPipe.transform(this.catalystCommentData, this.sortData.order, this.sortData.field);
    } else {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
    }
  }

  getData() {
    this.dataService.roeSelectedRecords = [];
    this.catReconCommentData = [];
    this.isDataLoading = true;
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterParams = this.prepareSearchParameters();
    Object.assign(filterParams, {startLimit: this.Limit.Start.toString(), 
      endLimit: this.Limit.End.toString()});

    /* set post dataset */
    this.CatReconCommentViewerService.getCatReconComments(filterParams)
    .subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
          /* Check whether User Clicked on Browse-Comments OR On Table Header/Table Cell */
          if(filterParams.commentSection==="Browse-Comments") {
            this.catReconCommentData = dataset.Data["allBrowsedComments"] ? dataset.Data["allBrowsedComments"] : [];
            this.totalRecords = dataset.Data["totalBrowsedCommentCount"] ? dataset.Data["totalBrowsedCommentCount"] : 0;
          } else {
            this.catReconCommentData = dataset.Data[this.panelKeys[this.selectedTabIndex]] ? dataset.Data[this.panelKeys[this.selectedTabIndex]] : [];
            this.totalRecords = dataset.Data["total"+this.panelKeys[this.selectedTabIndex]+"Count"] ? dataset.Data["total"+this.panelKeys[this.selectedTabIndex]+"Count"] : 0;
          }
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
   
          if (this.catReconCommentData.length === 0) {
            this.tbldatamsg = "No data found";
          }
          this.isDataLoading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }

  prepareSearchParameters() {
    this.LastExecutionDate = [];
    /* Option - 1 -> If DateRange is user Selectable & selects Custom Date Range 
       Option - 2 -> If User selected Header/Field has Date Range (e.g. - CAT Monthly Summary Tables) */
    if(this.catReconService.isDisplayDateRangeFilter && this.filterReportDate.length > 0) {
      this.LastExecutionDate.push(this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]));
      this.LastExecutionDate.push(this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]));
    } else if(Object.keys(this.selectedRow).length>0 && this.selectedRow.fromReportDate && this.selectedRow.toReportDate) {
      this.LastExecutionDate.push(this.selectedRow.fromReportDate);
      this.LastExecutionDate.push(this.selectedRow.toReportDate);
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.LastExecutionDate[0];
    filterData[0].values[1] = this.LastExecutionDate[1];

    let filterParams = {
      CATReporterIMID: this.userService.getActiveMPID(),
      commentSection: this.selectedRow.commentSection,
      groupName: this.selectedRow.groupName,
      reportDate: this.selectedRow.reportDate,
      cellValue: (this.selectedRow.fieldValue && this.selectedRow.fieldValue.toString()),
      panelName: (this.selectedRow.commentSection==="Browse-Comments" ? "" : this.panelNames[this.selectedTabIndex]),
      createdBy: this.userService.getUserName(),
      updatedBy: this.userService.getUserName(),
      columnKey: this.selectedRow.optedTableHeader!=undefined && this.selectedRow.optedTableHeader.length>0 ? this.selectedRow.optedTableHeader[0]:"",
      data: filterData
    };

    return filterParams;
  }

  getRowKey(index:any){
    let group =this.groupName;
    switch (index) {
      case 1:
        if(this.selectedRow.tableName == "Event Summary Table") {
          return this.selectedRow.clientDataEvents +(group ? '/'+ group:'');
        } else {
          return this.selectedRow.fileName + (group ? '/'+ group:'');
        }
      case 2:
        return this.selectedRow.fileName;
      case 3:
        return this.selectedRow.groupName;
      case 4:
        return this.selectedRow.groupName;
      default:
    }
  }

  addReconComment() {
    let filterData = {
      CATReporterIMID: this.userService.getActiveMPID(),
      groupName: this.selectedRow.groupName,
      reportDate: (this.selectedTabIndex===5 && this.tableName === "CAT Monthly Summary Table" ? this.selectedRow.fromReportDate : this.selectedRow.reportDate), // Set Initial ReportDate for CAT Monthly Summary otherwise ResportDate for all other options
      panelName: this.panelNames[this.selectedTabIndex],
      tableName: this.selectedRow.tableName,
      columnKey: this.selectedRow.optedTableHeader[0],
      rowKey: this.getRowKey(this.selectedTabIndex),
      cellValue: this.selectedRow[this.selectedRow.optedTableHeader[0]],
      Comment: this.commentStatement,
      createdBy: this.userService.getUserName(),
      updatedBy: this.userService.getUserName(),
      path: this.getRowKey(this.selectedTabIndex)
    };
    this.isDataLoading = true;
    this.CatReconCommentViewerService.addCatReconComment(filterData)
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        this.messageService.add({ severity: 'success', summary: 'Add Message', detail: dataset.Data });
        this.isDataLoading = false;
        this.getData();
        this.commentStatement = '';
        this.reloadCommentCount.emit(); // Reload All Comment Counts at Parent CAT Analytics Component
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment hasn\'t been Added' });
        this.isDataLoading = false;
      }
    });
  }

  showDateFilter() {
    this.isOpenDateRangeFilter = true;
  }

  applyFilter() {
    let fromdate = this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]);
    let todate = this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]);

    this.LastExecutionDate = [];
    if ((fromdate != "" || fromdate != undefined || fromdate != null) && (todate != "" || todate != undefined || todate != null)) {
      this.LastExecutionDate[0] = (fromdate); // Fromdate
      this.LastExecutionDate[1] = (todate); // Todate
    }

    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getData();
  }

  removeRecords(e:any) {
    let msg = '';
    if(this.dataService.roeSelectedRecords.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'User Action', detail: 'Please select any record to perform action' });
      return false;
    }
    if (this.dataService.roeSelectedRecords.length > 1) {
      msg = 'Are you sure that you want to delete All?';
    } else {
      msg = 'Are you sure that you want to delete?';
    }
    this.confirmationService.confirm({
      message: msg,
      acceptIcon:'pi pi-check',
      rejectIcon:'pi pi-times',
      key: 'DeleteconfirmationDialoge',
      accept: () => {
        let filterData = {
          CATReporterIMID: this.userService.getActiveMPID(),
          user: this.userService.getUserName(),
          userName: this.userService.getUserFirstName(),
          selectedRows: this.dataService.roeSelectedRecords,
          updatedBy: this.userService.getUserName()
        };
        this.isDataLoading = true;
        this.CatReconCommentViewerService.deleteCatReconComment(filterData)
        .subscribe({
          next: (Element: any) => {
            let dataset: any = Element;
            this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: dataset.Data });
            this.isDataLoading = false;
            this.getData();
            this.reloadCommentCount.emit(); // Reload All Comment Counts at Parent CAT Analytics Component
          },  
          error: (err: HttpErrorResponse) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment hasn\'t been Deleted' });
            this.isDataLoading = false;
          }
        });
      }
    });
    return false;
  }

  exportToCSV() {
    const filterParams = this.prepareSearchParameters();
    Object.assign(filterParams, { startLimit: this.Limit.Start.toString(), endLimit: this.totalRecords.toString() });

    this.CatReconCommentViewerService.exportCSV(this.gridColumns, filterParams);
  }

  closeDialogbox() {
    this.filterReportDate = [];
    this.commentStatement = "";
    this.dataService.roeSelectedRecords = [];
    this.catReconService.isOpenCommentViewer = false;
    /* Reset Pagination */
    this.totalRecords = 0;
    this.pageNumber = 1;
    this.dt.first = 1;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
  }
  getDateEmitter(){
    this.filterReportDate[0]=this.datepickerService.dateRange[0];
    this.filterReportDate[1]=this.datepickerService.dateRange[1];
  }

}